// [MOCK] 長條形（跨格大符號）注入 — 已驗證：Unity 的本地輪帶一律 Size=1，長條符號只從後端 Spin 結果
// （CellSymbol.Size 1~4）而來。本專案為離線 Mock，故在落盤時依機率主動注入長條符號以呈現此玩法。
// 表示法見 model/board.ts 檔頭（頂格 size>=2、延續格 size=0、同一符號 id）。
// 取得真實後端後，長條資料改由後端結果決定，本模組移除。

import { MAX_SYMBOL_SIZE, MOCK_TALL_SYMBOL_CHANCE } from '../constants'
import type { Board, ReelColumn } from '../model/board'

/** 每一欄獨立生成長條符號的機率（在整體 MOCK_TALL_SYMBOL_CHANCE 命中後才逐欄套用）。 */
const PER_REEL_TALL_CHANCE = 0.32

/**
 * 可注入的長條符號 id：WW/H1/H2/H3/H4。刻意排除 Scatter(12)——雖然 Unity 允許長條 Scatter，
 * 但一顆長條 Scatter 會佔多格、灌大 scatter 計數而在主遊戲頻繁誤觸發 Free Game，不利 Mock 展示。
 */
const MOCK_TALL_IDS: readonly number[] = [0, 1, 2, 3, 4]

/**
 * [MOCK] 在落盤盤面上注入長條符號（不變動輸入，回傳新盤面）。Tracker 頂輪只有單一橫排、不適用長條，故不處理。
 */
export function injectMockTallSymbols(board: Board): Board {
  if (Math.random() >= MOCK_TALL_SYMBOL_CHANCE) return board
  return board.map((column) => (Math.random() < PER_REEL_TALL_CHANCE ? placeTallInColumn(column) : column))
}

/** 在單一欄位隨機位置放入一顆長條符號（頂格 size=N、其下 N-1 格為 size=0 延續格，皆同一符號 id）。 */
function placeTallInColumn(column: ReelColumn): ReelColumn {
  const rows = column.length
  const maxSize = Math.min(MAX_SYMBOL_SIZE, rows)
  if (maxSize < 2) return column

  const size = 2 + Math.floor(Math.random() * (maxSize - 1)) // 2..maxSize
  const startRow = Math.floor(Math.random() * (rows - size + 1)) // 0..rows-size
  const symbol = MOCK_TALL_IDS[Math.floor(Math.random() * MOCK_TALL_IDS.length)]!

  return column.map((cell, row) => {
    if (row === startRow) return { symbol, size }
    if (row > startRow && row < startRow + size) return { symbol, size: 0 }
    return cell
  })
}
